import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Warehouse } from "lucide-react";
import DockDoorSettings from "../../../Appointments/TabContent/Calendar-Main/DockDoorSettings";

const EditWarehouseModal = ({
  warehouseName = "Warehouse",
  settings = { regularHours: {}, holidays: [], blackouts: [] },
  onClose,
  onSaved = () => {},
}) => {
  const [localSettings, setLocalSettings] = useState(settings);
  const [isSavingSettings, setIsSavingSettings] = useState(false);
  const settingsSaveRef = useRef(null);

  useEffect(() => {
    setLocalSettings(settings || { regularHours: {}, holidays: [], blackouts: [] });
  }, [settings]);

  const handleSave = async () => {
    const result = settingsSaveRef.current ? await settingsSaveRef.current() : true;
    if (result === false) return;

    await onSaved(localSettings);
    onClose();
  };

  const disableActions = isSavingSettings;

  return (
    <motion.div
      className="fixed inset-0 bg-black/40 z-[1500] flex items-center justify-center px-fluid-3 py-fluid-3"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="
          bg-white rounded-2xl shadow-xl 
          w-full 
          max-w-[95vw]
          md-max-w-[800px]
          lg-max-w-[1000px]
          xl-max-w-[1200px]
          2xl-max-w-[1400px]
          max-h-[95vh] 
          overflow-y-auto
          p-fluid-4 space-y-fluid-4
          border border-gray-200
        "
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        <div className="flex flex-col items-center space-y-fluid-2 border-b pb-fluid-3">
          <div className="bg-[#1e2a74] rounded-full p-fluid-2 text-white shadow-md">
            <Warehouse size={30} />
          </div>

          <h2 className="text-fluid-xl font-semibold text-[#111827]">
            Edit Warehouse
          </h2>

          <p className="text-fluid-base text-gray-600 text-center max-w-[620px]">
            Update calendar hours, holidays, blackouts, and appointment duration for{" "}
            <span className="font-semibold text-[#1e2a74]">{warehouseName}</span>.
          </p>
        </div>

        <div className="border rounded-xl p-fluid-3 bg-white shadow-sm">
          <DockDoorSettings
            settings={localSettings}
            onChange={(newSettings) => setLocalSettings(newSettings)}
            isViewOnly={false}
            isWarehouseView={true}
            registerHandleSave={(fn) => {
              settingsSaveRef.current = fn;
            }}
            onSaveComplete={() => {}}
            onSettingsSavingChange={setIsSavingSettings}
          />
        </div>

        <div className="flex items-center justify-end gap-fluid-3 pt-fluid-3 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="px-fluid-button-x py-fluid-button-y border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 text-fluid-sm transition"
            disabled={disableActions}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className={`
              px-fluid-button-x py-fluid-button-y 
              text-fluid-sm rounded-lg font-semibold transition
              ${!disableActions
                ? "bg-[#1e2a74] hover:bg-[#18225c] text-white"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }
            `}
            disabled={disableActions}
          >
            {isSavingSettings ? "Saving..." : "Save changes"}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default EditWarehouseModal;